<template>
    <div class="userinfo-wrap">
        <div class="section_1 flex-col">
            <div class="box_3 flex-col">
                <div class="box_4 flex-row justify-end">
                    <div class="image-text_1 flex-row justify-between">
                        <img class="label_1" referrerpolicy="no-referrer"
                            src="https://lanhu.oss-cn-beijing.aliyuncs.com/psainwl6hvd20rudi1rgw88j01jvvaemixe2mibxeqh9tfbt91783b069-9c9a-4007-816e-e5254ed6e7b6" />
                        <span class="text-group_1">VIP{{ level }}</span>
                    </div>
                    <div class="image-text_2 flex-row justify-between">
                        <span class="text-group_2">VIP</span>
                        <img class="label_2" referrerpolicy="no-referrer"
                            src="https://lanhu.oss-cn-beijing.aliyuncs.com/ps4zk7kb3v6hudte2971xyu7fu1i1nstt9svpyvm1l7m0zr52966ab1948-8ad0-4e2e-8b3f-04b1c44aadcb" />
                    </div>
                    <div class="image-text_3 flex-row justify-between">
                        <img class="image_1" referrerpolicy="no-referrer"
                            src="../views/images/avt.png" />
                        <span class="text-group_3">{{ username }}</span>
                    </div>
                </div>
                <div class="box_5 flex-row justify-between">
                    <span class="text_1">Apostas&nbsp;Acumuladas</span>
                    <div class="text-wrapper_1">
                        <span class="text_2">{{total_bet_amount}}/</span> <span class="text_3">{{ sub_level_amount }}</span>
                    </div>
                </div>
                <div class="box_6 flex-row justify-between">
                    <div class="box_7 flex-col">
                        <div class="box_8 flex-col" :style="{width:total_bet_amount/sub_level_amount*100 + '%'}"></div>
                    </div>
                    <span class="text_4">{{to100(total_bet_amount/sub_level_amount)}}%</span>
                </div>
                <!-- <div class="box_9 flex-row justify-between">
                    <span class="text_5">Recarga&nbsp;Cumulativa</span>
                    <div class="text-wrapper_2">
                        <span class="text_6">0/</span> <span class="text_7">0</span>
                    </div>
                </div>
                <div class="box_10 flex-row justify-between">
                    <div class="box_11 flex-col">
                        <div class="box_12 flex-col"></div>
                    </div>
                    <span class="text_8">54%</span>
                </div> -->
            </div>


            <div class="box_13 flex-row justify-between">
                <div class="group_2 flex-row">
                    <div class="image-text_4 flex-row " @click="$router.push('/invest')">
                        <img class="image_2" referrerpolicy="no-referrer" src="../views/images/user/wytx.png" />
                        <span class="text-group_4">Depósito</span>
                    </div>
                </div>
                <div class="group_2 flex-row">
                    <div class="image-text_4 flex-row " @click="$router.push('/cash')">
                        <img class="image_2" referrerpolicy="no-referrer" src="../views/images/user/re.png" />
                        <span class="text-group_4">Retirar</span>
                    </div>
                </div>
            </div>
            <div class="box_13 flex-row justify-between">
                <div class="group_2 flex-row">
                    <div class="image-text_4 flex-row " @click="$router.push('/bet_list')">
                        <img class="image_2" referrerpolicy="no-referrer" src="../views/images/user/ordern.png" />
                        <span class="text-group_4">Ordem</span>
                    </div>
                </div>
                <div class="group_2 flex-row">
                    <div class="image-text_4 flex-row" @click="$router.push('/vip')">
                        <img class="image_2" referrerpolicy="no-referrer" src="../views/images/user/vip.png" />
                        <span class="text-group_4">VIP Benefits</span>
                    </div>
                </div>
            </div>
            <div class="box_13 flex-row justify-between">
                <div class="group_2 flex-row" @click="showMsg()">
                    <div class="image-text_4 flex-row ">
                        <img class="image_2" referrerpolicy="no-referrer" src="../views/images/user/fankui.png" />
                        <span class="text-group_4">Opinião</span>
                    </div>
                </div>
                <div class="group_2 flex-row">
                    <div class="image-text_4 flex-row " @click="logout()">
                        <img class="image_2" referrerpolicy="no-referrer" src="../views/images/user/exit.png" />
                        <span class="text-group_4">Sair</span>
                    </div>
                </div>
            </div>

            <span class="text_14">V1.0.0.0</span>

            <!-- <button>close</button> -->
        </div>
       
    </div>
</template>

<script>
import Fetch from "@/utils/fetch";

export default {
    name: "userInfo",
    data() {
        return {
            phone: null,
            money: null,
            VIPname: null,
        }
    },
    props: ['username', 'level','total_bet_amount','sub_level_amount'],
    created() {

    },
 
    mounted() {
       // console.log(this.username)
    },
    methods: {
        showMsg() {
            this.$toast({
                background: "#07c160",
                message: "Obrigado pelo seu feedback. Recomendamos que você entre em contato com o atendimento ao cliente e eles anotarão seu comentário.",
                duration: 8000,
                className: "mytoast"
            });
            return;
        },
        logout() {
            Fetch('/user/logout').then((r) => {
                if (r.code == 1) {
                    window.location.href = "/";
                }
            });
        },
        to100(v){
            return (v*100).toFixed(2);
        }
    }
}
</script>

<style scoped lang="less">
.userinfo-wrap {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 10;
}

.page {
    position: relative;
    width: 100vw;
    height: 216.4vw;
    overflow: hidden;
}





.group_1 {
    background-color: rgba(0, 0, 0, 0.65);
    height: 216.4vw;
    width: 100vw;
}

.section_1 {
    width: 87.47vw;
    height: auto;
    background: rgb(14, 65, 20);
    background: url("../views/images/vip/vip.png");
    background-size: 100% 100%;
    margin: 15.06vw 0 0 6.26vw;
    border: 1px solid rgba(1, 40, 21, 0.259);
    border-radius: 10px;
}

.box_3 {
   
    border-radius: 24px 24px 0px 0px;
    width: 81.74vw;
    height: auto;
    padding-bottom: 20px;
    margin: 4.4vw 0 0 2.93vw;
}

.box_4 {
    position: relative;
    width: 74.67vw;
    height: 13.87vw;
    margin: 4.4vw 0 0 3.86vw;
}

.image-text_1 {
    width: 13.34vw;
    height: 4.8vw;
    margin: 8.26vw 0 0 16vw;
}

.label_1 {
    width: 5.34vw;
    height: 4.8vw;
}

.text-group_1 {
    width: 7.34vw;
    height: 2.8vw;
    overflow-wrap: break-word;
    color: rgba(251, 222, 82, 1);
    font-size: 3.46vw;
    font-family: PingFang-SC-Medium;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 3.47vw;
    margin-top: 0.94vw;
}

.image-text_2 {
    width: 11.07vw;
    height: 2.94vw;
    margin: 3.2vw 0 0 34.26vw;
}

.text-group_2 {
    width: 6.67vw;
    height: 2.67vw;
    overflow-wrap: break-word;
    color: rgba(251, 222, 82, 1);
    font-size: 3.46vw;
    font-family: PingFang-SC-Medium;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 3.47vw;
    margin-top: 0.27vw;
}

.label_2 {
    width: 2.94vw;
    height: 2.94vw;
}

.image-text_3 {
    position: absolute;
    left: 0;
    top: 0;
    width: 40vw;
    height: 13.87vw;
}

.image_1 {
    width: 13.87vw;
    height: 13.87vw;
}

.text-group_3 {
    text-shadow: 2px 3px 0px gold;
    //   background-image: linear-gradient(
    //     180deg,
    //     rgba(255, 176, 0, 1) 0,
    //     rgba(255, 176, 0, 1) 0,
    //     rgba(251, 224, 87, 1) 100%,
    //     rgba(251, 224, 87, 1) 100%
    //   );
    width: 23.47vw;
    height: 3.47vw;
    overflow-wrap: break-word;
    color: rgba(7, 63, 34, 1);
    font-size: 4.53vw;
    font-family: PingFang-SC-Bold;
    font-weight: 700;
    text-align: left;
    white-space: nowrap;
    line-height: 4.54vw;
    margin-top: 2vw;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.box_5 {
    // width: 65.34vw;
    padding-right: 5px;
    height: 3.34vw;
    margin: 3.86vw 0 0 3.73vw;
}

.text_1 {
    width: 36.07vw;
    height: 3.07vw;
    overflow-wrap: break-word;
    color: gold;
    font-size: 3.2vw;
    font-family: PingFang-SC-Medium;
    font-weight: 700;
    text-align: left;
    white-space: nowrap;

}

.text-wrapper_1 {
    // width: 5.34vw;
    height: 3.07vw;
    overflow-wrap: break-word;
    font-size: 0;
    font-family: PingFang-SC-Medium;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 3.2vw;
}

.text_2 {
    width: 5.34vw;
    height: 3.07vw;
    overflow-wrap: break-word;
    color: rgba(255,255,255,1);
    font-size: 3.2vw;
    font-family: PingFang-SC-Medium;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 3.2vw;
}

.text_3 {
    width: 5.34vw;
    height: 3.07vw;
    overflow-wrap: break-word;
    color: rgba(251, 222, 82, 1);
    font-size: 3.2vw;
    font-family: PingFang-SC-Medium;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 3.2vw;
}

.box_6 {
    width: 74.67vw;
    height: 2.4vw;
    margin: 0.93vw 0 0 3.73vw;
}

.box_7 {
    background-color: rgba(32, 77, 39, 0.8);
    border-radius: 3px;
    height: 15px;
    margin-top: 5px;
    width: 66.67vw;
}

.box_8 {
    box-shadow: 0px 2px 24px 0px rgba(157, 106, 68, 0.3);
    background-color: rgba(251, 222, 82, 1);
    border-radius: 3px;
    //width: 45%;
    height: 15px;
}

.text_4 {
    width: 6.14vw;
    height: 2.4vw;
    overflow-wrap: break-word;
    color: rgba(251, 222, 82, 1);
    font-size: 2.93vw;
    font-family: PingFang-SC-Medium;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 2.94vw;
    margin-top: 5px;
}

.box_9 {
    width: 65.07vw;
    height: 3.47vw;
    margin: 3.46vw 0 0 4vw;
}

.text_5 {

    width: 36.47vw;
    height: 3.2vw;
    overflow-wrap: break-word;
    color: gold;
    font-size: 3.2vw;
    font-family: PingFang-SC-Medium;
    font-weight: 700;
    text-align: left;
    white-space: nowrap;
    line-height: 3.2vw;

}

.text-wrapper_2 {
    width: 5.34vw;
    height: 3.07vw;
    overflow-wrap: break-word;
    font-size: 0;
    font-family: PingFang-SC-Medium;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 3.2vw;
}

.text_6 {
    width: 5.34vw;
    height: 3.07vw;
    overflow-wrap: break-word;
    color: rgba(19, 40, 22, 1);
    font-size: 3.2vw;
    font-family: PingFang-SC-Medium;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 3.2vw;
}

.text_7 {
    width: 5.34vw;
    height: 3.07vw;
    overflow-wrap: break-word;
    color: rgba(251, 222, 82, 1);
    font-size: 3.2vw;
    font-family: PingFang-SC-Medium;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 3.2vw;
}

.box_10 {
    width: 74.67vw;
    height: 2.4vw;
    margin: 0.8vw 0 3.73vw 3.73vw;
}

.box_11 {
    background-color: rgba(19, 40, 22, 0.3);
    border-radius: 3px;
    height: 1.07vw;
    margin-top: 0.8vw;
    width: 66.67vw;
}

.box_12 {
    box-shadow: 0px 2px 24px 0px rgba(157, 106, 68, 0.3);
    background-color: rgba(251, 222, 82, 1);
    border-radius: 3px;
    width: 36.54vw;
    height: 1.07vw;
}

.text_8 {
    width: 6.27vw;
    height: 2.4vw;
    overflow-wrap: break-word;
    color: rgba(251, 222, 82, 1);
    font-size: 2.93vw;
    font-family: PingFang-SC-Medium;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 2.94vw;
}

.box_13 {
    width: 82.14vw;
    height: 13.34vw;
    margin: 1.86vw 0 0 2.66vw;
}

.group_2 {
    background-color: #29753733;
    border-radius: 16px;
    width: 40vw;
    height: 13.34vw;
    align-items: center;
}

.image-text_4 {
    width: 24.67vw;
    height: 7.87vw;
    // margin: 2.93vw 0 0 3.73vw;
    margin-left: 3vw;
    align-items: center;
}

.image_2 {
    width: 7.07vw;
    // height: 7.87vw;
}

.text-group_4 {

    overflow-wrap: break-word;
    color: rgba(252, 217, 73, 1);
    font-size: 3.73vw;
    font-family: PingFang-SC-Medium;
    font-weight: 700;
    text-align: left;
    white-space: nowrap;
    margin-left: 2vw;

}

.group_3 {
    background-color: rgba(41, 117, 55, 1);
    border-radius: 16px;
    width: 40vw;
    height: 13.34vw;
}

.image-text_5 {
    width: 21.34vw;
    height: 5.47vw;
    margin: 4.13vw 0 0 3.46vw;
}

.image_3 {
    width: 7.2vw;
    height: 5.47vw;
}

.text-group_5 {
    width: 11.47vw;
    height: 2.94vw;
    overflow-wrap: break-word;
    color: rgba(252, 217, 73, 1);
    font-size: 3.73vw;
    font-family: PingFang-SC-Medium;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 6.14vw;
    margin-top: 1.34vw;
}

.box_14 {
    width: 82.14vw;
    height: 13.34vw;
    margin: 2.4vw 0 0 2.66vw;
}

.group_4 {
    background-color: rgba(41, 117, 55, 1);
    border-radius: 16px;
    width: 40vw;
    height: 13.34vw;
}

.label_3 {
    width: 6.4vw;
    height: 6.27vw;
    margin: 3.73vw 0 0 4vw;
}

.text_9 {
    width: 13.74vw;
    height: 2.94vw;
    overflow-wrap: break-word;
    color: rgba(252, 217, 73, 1);
    font-size: 3.73vw;
    font-family: PingFang-SC-Medium;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 6.14vw;
    margin: 5.46vw 12.93vw 0 2.93vw;
}

.group_5 {
    background-color: rgba(41, 117, 55, 1);
    border-radius: 16px;
    width: 40vw;
    height: 13.34vw;
}

.label_4 {
    width: 5.87vw;
    height: 6.54vw;
    margin: 3.6vw 0 0 4.13vw;
}

.text_10 {
    width: 12.27vw;
    height: 2.94vw;
    overflow-wrap: break-word;
    color: rgba(252, 217, 73, 1);
    font-size: 3.73vw;
    font-family: PingFang-SC-Medium;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 6.14vw;
    margin: 5.46vw 14.4vw 0 3.33vw;
}

.box_15 {
    width: 82.14vw;
    height: 13.34vw;
    margin: 2.53vw 0 0 2.66vw;
}

.group_6 {
    background-color: rgba(41, 117, 55, 1);
    border-radius: 16px;
    width: 40vw;
    height: 13.34vw;
}

.label_5 {
    width: 6vw;
    height: 6.4vw;
    margin: 4vw 0 0 4.26vw;
}

.text_11 {
    width: 11.47vw;
    height: 2.94vw;
    overflow-wrap: break-word;
    color: rgba(252, 217, 73, 1);
    font-size: 3.73vw;
    font-family: PingFang-SC-Medium;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 6.14vw;
    margin: 5.46vw 15.2vw 0 3.06vw;
}

.group_7 {
    background-color: rgba(41, 117, 55, 1);
    border-radius: 16px;
    width: 40vw;
    height: 13.34vw;
}

.image-text_6 {
    width: 30.8vw;
    height: 6.4vw;
    margin: 4.13vw 0 0 3.46vw;
}

.image_4 {
    width: 7.2vw;
    height: 6.4vw;
}

.text-group_6 {
    width: 20.94vw;
    height: 3.6vw;
    overflow-wrap: break-word;
    color: rgba(252, 217, 73, 1);
    font-size: 3.73vw;
    font-family: PingFang-SC-Medium;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 6.14vw;
    margin-top: 1.34vw;
}

.box_16 {
    width: 82.14vw;
    height: 13.34vw;
    margin: 2.4vw 0 0 2.66vw;
}

.box_17 {
    background-color: rgba(41, 117, 55, 1);
    border-radius: 16px;
    width: 40vw;
    height: 13.34vw;
}

.label_6 {
    width: 6.14vw;
    height: 6.54vw;
    margin: 3.6vw 0 0 4.13vw;
}

.text_12 {
    width: 13.2vw;
    height: 3.6vw;
    overflow-wrap: break-word;
    color: rgba(252, 217, 73, 1);
    font-size: 3.73vw;
    font-family: PingFang-SC-Medium;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 6.14vw;
    margin: 5.33vw 13.46vw 0 3.06vw;
}

.box_18 {
    background-color: rgba(41, 117, 55, 1);
    border-radius: 16px;
    width: 40vw;
    height: 13.34vw;
}

.label_7 {
    width: 6.14vw;
    height: 6.54vw;
    margin: 3.6vw 0 0 4vw;
}

.text_13 {
    width: 6.67vw;
    height: 2.94vw;
    overflow-wrap: break-word;
    color: rgba(252, 217, 73, 1);
    font-size: 3.73vw;
    font-family: PingFang-SC-Medium;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 6.14vw;
    margin: 5.33vw 20vw 0 3.2vw;
}

.text_14 {
    width: 13.2vw;
    height: 2.67vw;
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    font-size: 3.46vw;
    font-family: PingFang-SC-Medium;
    font-weight: 500;
    text-align: left;
    white-space: nowrap;
    line-height: 6.14vw;
    margin: 4.8vw 0 3.6vw 36.26vw;
}

body * {
    box-sizing: border-box;
    flex-shrink: 0;
}

body {
    font-family: PingFangSC-Regular, Roboto, Helvetica Neue, Helvetica, Tahoma,
        Arial, PingFang SC-Light, Microsoft YaHei;
}

input {
    background-color: transparent;
    border: 0;
}

button {
    margin: 0;
    padding: 0;
    border: 1px solid transparent;
    outline: none;
    background-color: transparent;
}

button:active {
    opacity: 0.6;
}

.van-nav-bar__left:active,
.van-nav-bar__right:active {
    opacity: 1;
}

[class*='van-']::after {
    border-bottom: 0;
}

.flex-col {
    display: flex;
    flex-direction: column;
}

.flex-row {
    display: flex;
    flex-direction: row;
}

.justify-start {
    display: flex;
    justify-content: flex-start;
}

.justify-center {
    display: flex;
    justify-content: center;
}

.justify-end {
    display: flex;
    justify-content: flex-end;
}

.justify-evenly {
    display: flex;
    justify-content: space-evenly;
}

.justify-around {
    display: flex;
    justify-content: space-around;
}

.justify-between {
    display: flex;
    justify-content: space-between;
}

.align-start {
    display: flex;
    align-items: flex-start;
}

.align-center {
    display: flex;
    align-items: center;
}

.align-end {
    display: flex;
    align-items: flex-end;
}
</style>